
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[cityTitle]/[hotelTitle]",
      function () {
        return require("private-next-pages/[cityTitle]/[hotelTitle]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[cityTitle]/[hotelTitle]"])
      });
    }
  